<ui-auth-layout>
  <div class="auth-heading">
    <h1 class="auth-heading__title">{{ 'authentication.enter_new_password' | translate }}</h1>
    <p class="auth-heading__subtitle">{{ 'authentication.new_password_subtitle' | translate }}</p>
  </div>

  <form
    class="auth-form"
    [formGroup]="newPasswordForm"
    (ngSubmit)="resetPassword()"
    (keydown.enter)="onEnterKey($event)"
  >
    <ui-form-field
      [id]="'new_password'"
      formControlName="new_password"
      autocomplete="new-password"
      [type]="newPasswordVisible ? 'text' : 'password'"
      [label]="'authentication.new_password' | translate"
      [placeholder]="'authentication.password_placeholder' | translate"
      [suffixIcon]="newPasswordVisible ? 'eye-off-cc' : 'eye-cc'"
      [suffixIconClickable]="true"
      [suffixIconPressed]="newPasswordVisible"
      [suffixIconAriaLabel]="
        (newPasswordVisible ? 'authentication.hide_password' : 'authentication.show_password') | translate
      "
      (suffixIconClick)="newPasswordVisible = !newPasswordVisible"
      [errorMessages]="{
        required: 'authentication.required_new_password' | translate,
        pattern: 'authentication.password_must_contain' | translate
      }"
      [fullWidth]="true"
    ></ui-form-field>

    <ui-form-field
      [id]="'confirm_password'"
      formControlName="confirm_password"
      autocomplete="new-password"
      [type]="confirmPasswordVisible ? 'text' : 'password'"
      [label]="'authentication.confirm_password' | translate"
      [placeholder]="'authentication.password_placeholder' | translate"
      [suffixIcon]="confirmPasswordVisible ? 'eye-off-cc' : 'eye-cc'"
      [suffixIconClickable]="true"
      [suffixIconPressed]="confirmPasswordVisible"
      [suffixIconAriaLabel]="
        (confirmPasswordVisible ? 'authentication.hide_password' : 'authentication.show_password') | translate
      "
      (suffixIconClick)="confirmPasswordVisible = !confirmPasswordVisible"
      [errorMessages]="{
        required: 'authentication.required_confirm_password' | translate,
        mismatch: 'authentication.passwords_must_match' | translate
      }"
      [fullWidth]="true"
    ></ui-form-field>

    <div class="auth-form__actions">
      <ui-button
        type="primary"
        [label]="'authentication.reset_password' | translate"
        [fullWidth]="true"
      ></ui-button>

      <a class="auth-link" [routerLink]="['/login']">
        <ui-svg-icon svgIcon="chevron-right-cc" size="small" [rotated]="true"></ui-svg-icon>
        {{ 'authentication.back_to_login' | translate }}
      </a>
    </div>
  </form>
</ui-auth-layout>
